const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDivano = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 257.29 100.75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M225.73.38H31.46A9.61,9.61,0,0,0,21.85,10V60.44H235.34V10a9.61,9.61,0,0,0-9.61-9.6Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M33.47,100.38h-5V80.46h10Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M223.72,100.38h5V80.46h-9.95Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M247.14,20.4A10.14,10.14,0,0,0,237.32,29l-5.2,31.4H25.17L20,29a10.14,10.14,0,0,0-9.82-8.64A9.82,9.82,0,0,0,.51,31.83L7.24,72.42a9.61,9.61,0,0,0,9.48,8H240.57a9.61,9.61,0,0,0,9.48-8l6.73-40.59a9.82,9.82,0,0,0-9.64-11.43Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M123.79,40.42H26.66a4.81,4.81,0,0,0-4.81,4.8V55.63a4.82,4.82,0,0,0,4.81,4.81h97.13a4.81,4.81,0,0,0,4.8-4.81V45.22A4.8,4.8,0,0,0,123.79,40.42Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M230.53,40.42H133.4a4.81,4.81,0,0,0-4.81,4.8V55.63a4.82,4.82,0,0,0,4.81,4.81h97.13a4.82,4.82,0,0,0,4.81-4.81V45.22A4.81,4.81,0,0,0,230.53,40.42Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDivano);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/divano.7f49aa580e4d1f3c385773e29fb01b2b.svg";